<template>
    <v-dialog
        v-if="dialog"
        v-model="dialog"
        width="500"
        :fullscreen="false"
        :persistent="true"
        scrollable
    >
        <v-card>
            <ModalTitle :title="$t('question.create.confirmTypeChange.title')" :name="'CONFIRM_TYPE_CHANGE'"/>
            <v-card-text class="body-1 pt-5 pr-6 pl-6 pb-5">
                <v-card class="pa-5" color="orange lighten-5" elevation="0">
                    <span class="orange--text">
                    {{ $t('question.create.confirmTypeChange.text') }}
                    </span>
                </v-card>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-5 pr-5">
                <div class="text-right">
                <v-btn
                    @click="cancel()"
                    elevation="0"
                    color="grey"
                    text
                >
                    {{ $t('question.create.confirmTypeChange.buttons.cancel') }}
                </v-btn>
                <v-btn
                    @click="confirm"
                    color="orange"
                    elevation="0"
                    class="ml-5"
                    dark
                >
                    {{ $t('question.create.confirmTypeChange.buttons.confirm') }}
                </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ModalTitle from '@/components/app/modal/ModalTitle'
export default {
    name: 'ModalConfirmTypeChange',

    components: {
        ModalTitle,
    },
    data() {
        return {
            callbackFunction: null,
            dialog: false,
        }
    },
    methods: {
        open(callbackFunction) {
            this.dialog = true
            this.callbackFunction = callbackFunction
        },
        cancel() {
            this.dialog = false
            this.$emit('cancel')
        },
        confirm() {
            this.callbackFunction()
            this.dialog = false
        },
    },
}
</script>
